import {Track} from '@app/web-player/tracks/track';
import {useTrans} from '@ui/i18n/use-trans';
import {message} from '@ui/i18n/message';
import clsx from 'clsx';
import {MusicNoteIcon} from '@ui/icons/material/MusicNote';
import {getTrackImageSrc as getTrackImage} from '@app/web-player/media-image/media-image';

interface TrackImageProps {
  track: Track;
  className?: string;
  size?: string;
  background?: string;
  contentFormat?: string;
}
export function TrackImage({
  track,
  className,
  size,
  background = 'bg-fg-base/4',
  contentFormat,
}: TrackImageProps) {
  const {trans} = useTrans();
  const src = getTrackImage(track, contentFormat);
  const imgClassName = clsx(
    className,
    size,
    background,
    'object-cover',
    !src ? 'flex items-center justify-center' : 'block',
  );
  return src ? (
    <img
      className={imgClassName}
      draggable={false}
      loading="lazy"
      src={src}
      alt={trans(message('Image for :name', {values: {name: track.name}}))}
    />
  ) : (
    <span className={clsx(imgClassName, 'overflow-hidden')}>
      <MusicNoteIcon className="max-w-[60%] text-divider" size="text-9xl" />
    </span>
  );
}

export function getTrackImageSrc(track: Track, contentFormat?: string) {
  return getTrackImage(track, contentFormat);
}
